import { formatMoney } from "infra/helpers/number";
import colors from "core/resources/theme/colors";
import { Flex, Text, Collapse } from "@chakra-ui/react";
import { useState } from "react";
import React from "react";

function CollapseTaxas({
  taxas,
}: {
  taxas: { texto: string; valor: number }[];
}) {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Flex flexDir="column" mt={6} mb={2}>
      <Text
        as="a"
        color={colors.blue500}
        _hover={{ opacity: 0.7 }}
        cursor="pointer"
        onClick={() => setCollapsed((s) => !s)}
        mb={4}
      >
        {collapsed ? "Ver taxas de uso para este espaço" : "Ver menos"}
      </Text>

      <Collapse in={!collapsed}>
        <Flex gridGap={"16px 16px"} flexWrap="wrap">
          {taxas.map((taxa) => (
            <Flex
              w="calc(50% - 16px)"
              justifyContent="space-between"
              alignItems="center"
              px={2}
              py={4}
              borderWidth={1}
              borderColor={colors.blueishGray100}
              rounded="lg"
            >
              <Text fontSize={14}>
                {taxa.texto[0].toUpperCase() + taxa.texto.slice(1)}
              </Text>
              <Text fontSize={14} fontWeight="bold" color={colors.blue}>
                {formatMoney(taxa.valor)}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Collapse>
    </Flex>
  );
}

export default CollapseTaxas;
